import styles from "./radio-label.module.less";
import { motion } from "polyfill/motion-polyfill/motion-polyfill";

const RadioLabel = ({ name, color, isActive, numberOfSelected, totalPasses }) => {
  return (
    <div className={[styles.radioLabel, isActive ? styles.active : ""].join(" ")}>
      <div className={styles.circleWrapper}>
        <div style={{ borderColor: color }} className={styles.radioCircle}>
          {isActive && (
            <motion.div
              layoutId="radioFiller"
              transition={{ type: "spring", stiffness: 400, damping: 30 }}
              animate={{ background: color }}
              className={styles.radioFiller}
            />
          )}
        </div>
      </div>

      <div className={styles.name} style={{ color: isActive ? color : undefined }}>
        {name}
      </div>

      <div className={[styles.numberOfSelected].join(" ")}>
        ({numberOfSelected}/{totalPasses})
      </div>
    </div>
  );
};

export default RadioLabel;
